import * as React from 'react';

// @ts-ignore
import { AdapterDateFns } from '@emburse/ui-core/dist/AdapterDateFns';
import { EmburseUIProvider } from '@emburse/ui-essentials';

import { AbacusThemeProvider } from '@ReactComponents/Layout/ThemeProvider';

const AbacusEmbarkProvider: React.FC<{ children?: React.ReactNode }> = function ({ children }) {
  return (
    <EmburseUIProvider
      featureFlags={{ legacyI18nSupport: true, useGridProFeatures: true }}
      theme={{ designToken: AbacusThemeProvider.getThemeOptions(), responsive: { sidebar: true } }}
      dateLocale={{ dateAdapter: AdapterDateFns }}
    >
      {children}
    </EmburseUIProvider>
  );
};

export { AbacusEmbarkProvider };
